"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BEFORE_LAYER () {
        return BEFORE_LAYER;
    },
    get BLANK_STYLE_ID () {
        return BLANK_STYLE_ID;
    },
    get CUSTOM_MAPS_SOURCE_LAYER () {
        return CUSTOM_MAPS_SOURCE_LAYER;
    },
    get FLOODZONES_SOURCE_LAYER () {
        return FLOODZONES_SOURCE_LAYER;
    },
    get MAPBOX_OWNER_ID () {
        return MAPBOX_OWNER_ID;
    },
    get SATTELITE_COLORIZED_ID () {
        return SATTELITE_COLORIZED_ID;
    },
    get STATIC_IMAGE_HEIGHT () {
        return STATIC_IMAGE_HEIGHT;
    },
    get STATIC_IMAGE_WIDTH () {
        return STATIC_IMAGE_WIDTH;
    }
});
const FLOODZONES_SOURCE_LAYER = "floodzones";
const BEFORE_LAYER = "ground";
const SATTELITE_COLORIZED_ID = "clrlkqei3001i01q2ei3o3399";
const BLANK_STYLE_ID = "clvvd9r5r066u01pecc0s2rz2";
const MAPBOX_OWNER_ID = "sashako";
const STATIC_IMAGE_WIDTH = 700;
const STATIC_IMAGE_HEIGHT = 700;
const CUSTOM_MAPS_SOURCE_LAYER = "custom-map";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3V0aWxzL21hcHMvY29uc3RhbnRzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBGTE9PRFpPTkVTX1NPVVJDRV9MQVlFUiA9IFwiZmxvb2R6b25lc1wiO1xuZXhwb3J0IGNvbnN0IEJFRk9SRV9MQVlFUiA9IFwiZ3JvdW5kXCI7XG5leHBvcnQgY29uc3QgU0FUVEVMSVRFX0NPTE9SSVpFRF9JRCA9IFwiY2xybGtxZWkzMDAxaTAxcTJlaTNvMzM5OVwiO1xuZXhwb3J0IGNvbnN0IEJMQU5LX1NUWUxFX0lEID0gXCJjbHZ2ZDlyNXIwNjZ1MDFwZWNjMHMycnoyXCI7XG5leHBvcnQgY29uc3QgTUFQQk9YX09XTkVSX0lEID0gXCJzYXNoYWtvXCI7XG5leHBvcnQgY29uc3QgU1RBVElDX0lNQUdFX1dJRFRIID0gNzAwO1xuZXhwb3J0IGNvbnN0IFNUQVRJQ19JTUFHRV9IRUlHSFQgPSA3MDA7XG5leHBvcnQgY29uc3QgQ1VTVE9NX01BUFNfU09VUkNFX0xBWUVSID0gXCJjdXN0b20tbWFwXCI7XG5leHBvcnQgdHlwZSBJbWFnZVNjYWxlID0gMSB8IDIgfCA0O1xuIl0sIm5hbWVzIjpbIkJFRk9SRV9MQVlFUiIsIkJMQU5LX1NUWUxFX0lEIiwiQ1VTVE9NX01BUFNfU09VUkNFX0xBWUVSIiwiRkxPT0RaT05FU19TT1VSQ0VfTEFZRVIiLCJNQVBCT1hfT1dORVJfSUQiLCJTQVRURUxJVEVfQ09MT1JJWkVEX0lEIiwiU1RBVElDX0lNQUdFX0hFSUdIVCIsIlNUQVRJQ19JTUFHRV9XSURUSCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7UUFDYUE7ZUFBQUE7O1FBRUFDO2VBQUFBOztRQUlBQztlQUFBQTs7UUFQQUM7ZUFBQUE7O1FBSUFDO2VBQUFBOztRQUZBQztlQUFBQTs7UUFJQUM7ZUFBQUE7O1FBREFDO2VBQUFBOzs7QUFMTixNQUFNSiwwQkFBMEI7QUFDaEMsTUFBTUgsZUFBZTtBQUNyQixNQUFNSyx5QkFBeUI7QUFDL0IsTUFBTUosaUJBQWlCO0FBQ3ZCLE1BQU1HLGtCQUFrQjtBQUN4QixNQUFNRyxxQkFBcUI7QUFDM0IsTUFBTUQsc0JBQXNCO0FBQzVCLE1BQU1KLDJCQUEyQiJ9